import Dexie from "dexie";
import 'dexie-observable';
import moment, {isMoment} from "moment";
import * as R from 'ramda';
import uuid from 'uuid';

export const db = new Dexie("cproject");

db.version(1).stores({
  notifications: "historyid,contactuserid,associatedid",
});
db.version(2).stores({
  notifications: "historyid,contactuserid,associatedid,userid",
});


export class DexieHooks {
  constructor() {
    this.hooks = [];
  }

  static CREATED = 1;
  static UPDATED = 2;
  static DELETED = 3;

  register(table, type, callback) {
    let id = uuid.v4();
    let hook = {
      id,
      table,
      type,
      callback
    };
    this.hooks = R.append(hook, this.hooks);
    return id;
  }

  deregister(id) {
    this.hooks = R.filter(x => x.id !== id, this.hooks);
  }

  run(store) {
    this.dispatch = store.dispatch;
    db.on('changes', changes => {
      for (let change of changes) {
        for (let hook of this.hooks) {
          if (change.type === hook.type && change.table === hook.table) {
            hook.callback(this.dispatch, change);
          }
        }
      }
    });
  }
}

const momentToVal = x => {
  if (isMoment(x)) {
    return { _moment: x.valueOf() };
  } else return x;
};

const valToMoment = x => {
  if (x instanceof Object && R.has('_moment', x)) {
    return moment(x._moment);
  } else return x;
};

export const dehydrate = R.map(momentToVal);
export const hydrate = R.map(valToMoment);



// WEBPACK FOOTER //
// ./src/reducers/persistence.js